// --- BASE ---
import React from 'react';

// --- HELPERS ---
import { convertTicks } from '../Helpers';

// --- INTERFACES ---
interface IProps {
	alert: object;
	onClose?: () => void;
}

// *** FUNCTIONAL COMPONENT ***
const AlertBox = (props: IProps) => {
	// --- PROPS ---
	const { alert, onClose }: IProps = { ...props };

	// --- CONSTANTS ---
	const message = typeof alert === 'object' && alert !== null && 'message' in alert && typeof alert.message === 'string' && alert.message !== null ? convertTicks(alert.message) : '';
	const show = typeof alert === 'object' && alert !== null && 'show' in alert && typeof alert.show === 'boolean' && alert.show !== null ? alert.show : false;
	const status = 'status' in alert && typeof alert.status === 'string' && alert.status !== null ? alert.status : 'error';

	return (
		<div
			className={['danger', 'info', 'success', 'warning'].includes(status) ? 'alert alert-dismissible alert-' + status : 'alert alert-dismissible alert-danger'}
			hidden={show ? false : true}
			role="alert">
			{message}
			<button
				aria-label="Close"
				className="btn-close"
				data-bs-dismiss="alert"
				onClick={onClose}
				type="button" />
		</div>
	);
};

export default AlertBox;
